
interface ScheduleItem {
  id: number;
  date: string;
  day: string;
  time: string;
  doorOpen: string;
  venue: string;
  artist: string;
  title: string;
  genre: string;
  price: number;
  ticketUrl: string;
  status: string;
  description: string;
}

interface ScheduleCardProps {
  item: ScheduleItem;
  onDetailClick: (item: ScheduleItem) => void;
}

export default function ScheduleCard({ item, onDetailClick }: ScheduleCardProps) {
  const dateParts = item.date.split('-');
  const month = parseInt(dateParts[1], 10);
  const dayNum = parseInt(dateParts[2], 10);

  const dayColorMap: Record<string, string> = {
    '土': 'text-teal-600',
    '日': 'text-rose-500',
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg hover:shadow-md transition-all duration-200 group">
      <div className="flex flex-col md:flex-row">
        {/* Date Column */}
        <div className="flex-shrink-0 md:w-24 p-5 flex flex-col items-center justify-center md:border-r border-gray-100">
          <span className="text-xs text-gray-400 font-medium">{month}月</span>
          <span className="text-3xl font-bold text-gray-900 leading-none mt-1">{dayNum}</span>
          <span className={`text-xs font-medium mt-1 ${dayColorMap[item.day] || 'text-gray-500'}`}>
            {item.day}曜日
          </span>
        </div>

        {/* Content */}
        <div className="flex-grow p-5 flex flex-col md:flex-row md:items-center gap-4">
          <div className="flex-grow min-w-0">
            <div className="flex flex-wrap items-center gap-2 mb-2">
              <h3 className="text-base font-bold text-gray-900 truncate">{item.artist} / {item.title}</h3>
              <span className="px-2.5 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-full whitespace-nowrap font-medium">
                {item.genre}
              </span>
            </div>
            <p className="text-sm text-gray-500 mb-3 line-clamp-1">{item.description}</p>
            <div className="flex flex-wrap gap-x-5 gap-y-1.5 text-sm text-gray-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-map-pin-2-line text-gray-400 w-4 h-4 flex items-center justify-center"></i>
                {item.venue}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-door-open-line text-gray-400 w-4 h-4 flex items-center justify-center"></i>
                開場 {item.doorOpen}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-play-circle-line text-gray-400 w-4 h-4 flex items-center justify-center"></i>
                開演 {item.time}
              </span>
            </div>
          </div>

          {/* Price & Action */}
          <div className="flex-shrink-0 flex md:flex-col items-center md:items-end gap-3 md:gap-2 md:ml-4">
            <div className="text-right">
              <span className="text-xs text-gray-400">前売</span>
              <p className="text-xl font-bold text-gray-900">&yen;{item.price.toLocaleString()}</p>
            </div>
            <button
              onClick={() => onDetailClick(item)}
              className="px-5 py-2 bg-gray-900 text-white rounded-md text-sm font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              詳細を見る
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
